import { Injectable, inject } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { ElectronAuthService } from '../services/electron-auth.service';

@Injectable({
  providedIn: 'root'
})
export class ElectronAuthGuard implements CanActivate {

  private readonly _electronAuthService = inject(ElectronAuthService);
  private readonly _router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {

    return this._electronAuthService.isAuthenticated().pipe(
      switchMap(isAuthenticated => {
        if (isAuthenticated) {
          return of(true);
        }

        return this._electronAuthService.initializeElectronAuth().pipe(
          map(user => {
            if (user) {
              return true;
            } else {
              this._router.navigate(['/no-registered']);
              return false;
            }
          })
        );
      })
    );
  }
}